const FETCH_NUMBERS_SUBMIT = (state) => {
  state.fetchNumbersInProcess = true
  state.inProgress.fetchNumbers = true
}

const FETCH_NUMBERS_RESPONSE = (state, data) => {
  state.numbers = data
  state.fetchNumbersInProcess = false
  state.inProgress.fetchNumbers = false
}

const FETCH_NUMBERS_ERROR_RESPONSE = (state, data) => {
  state.errors.fetchNumbers = false
  state.inProgress.fetchNumbers = false
}

const SET_NUMBER_AS_PRIMARY_SUBMIT = (state, data) => {
  state.inProgress.setNumberAsPrimarty = true
}

const SET_NUMBER_AS_PRIMARY_RESPONSE = (state, data) => {
  state.inProgress.setNumberAsPrimarty = false
}

const SET_NUMBER_AS_PRIMARY_ERROR_RESPONSE = (state, data) => {
  state.errors.setNumberAsPrimarty = false
  state.inProgress.setNumberAsPrimarty = false
}
const DELETE_NUMBER_SUBMIT = (state, data) => {
  state.inProgress.deleteNumber = true
}
const DELETE_NUMBER_RESPONSE = (state, data) => {
  state.inProgress.deleteNumber = false
}
const DELETE_NUMBER_ERROR_RESPONSE = (state, data) => {
  state.errors.deleteNumber = false
  state.inProgress.deleteNumber = false
}

const GET_CALLER_REGIONS_SUBMIT = (state) => {
  state.inProgress.getCallerRegions = true
}
const GET_CALLER_REGIONS_RESPONSE = (state, data) => {
  state.callerRegions = data
  state.inProgress.getCallerRegions = false
}
const GET_CALLER_REGIONS_ERROR_RESPONSE = (state, data) => {
  state.errors.getCallerRegions = false
  state.inProgress.getCallerRegions = false
}

const SET_CALLER_REGION_SUBMIT = (state, data) => {
  state.inProgress.setCallerRegion = true
}
const SET_CALLER_REGION_RESPONSE = (state, data) => {
  state.inProgress.setCallerRegion = false
}
const SET_CALLER_REGION_ERROR_RESPONSE = (state, data) => {
  state.errors.setCallerRegion = false
  state.inProgress.setCallerRegion = false
}

const ADD_NUMBER_SUBMIT = (state) => {
  state.errors.addNumber = false
  state.inProgress.addNumber = true
}
const ADD_NUMBER_RESPONSE = (state, data) => {
  state.inProgress.addNumber = false
}
const ADD_NUMBER_ERROR_RESPONSE = (state, data) => {
  state.errors.addNumber = data
  state.inProgress.addNumber = false
}

const VERIFY_NUMBER_BY_SMS_SUBMIT = (state) => {
  state.inProgress.verifyBySMS = true
}
const VERIFY_NUMBER_BY_SMS_RESPONSE = (state, data) => {
  state.inProgress.verifyBySMS = false
}
const VERIFY_NUMBER_BY_SMS_ERROR_RESPONSE = (state, data) => {
  state.errors.verifyBySMS = false
  state.inProgress.verifyBySMS = false
}

const VERIFY_NUMBER_RECIVED_CODE_SUBMIT = (state) => {
  state.inProgress.verifyWithRecivedCode = true
  state.errors.verifyWithRecivedCode = false
}
const VERIFY_NUMBER_RECIVED_CODE_RESPONSE = (state, data) => {
  state.inProgress.verifyWithRecivedCode = false
}
const VERIFY_NUMBER_RECIVED_CODE_ERROR_RESPONSE = (state, data) => {
  state.errors.verifyWithRecivedCode = true
  state.inProgress.verifyWithRecivedCode = false
}

const VERIFY_NUMBER_BY_CALL_SUBMIT = (state) => {
  state.inProgress.verifyByCall = true
}
const VERIFY_NUMBER_BY_CALL_RESPONSE = (state, data) => {
  state.inProgress.verifyByCall = false
}
const VERIFY_NUMBER_BY_CALL_ERROR_RESPONSE = (state, data) => {
  state.errors.verifyByCall = data
  state.inProgress.verifyByCall = false
}

const VERIFY_NUMBER_BY_CALL_VERIFIED_COUNTER = (state, data) => {
  state.checkVerifyNumberByCallCounter++
  state.verifyByCallCallingInProgress = true
}

const VERIFY_NUMBER_BY_CALL_VERIFIED_FAILED = (state, data) => {
  state.errors.verifyByCallCalling = true
  state.verifyByCallCallingInProgress = false
}

const VERIFY_NUMBER_BY_CALL_VERIFIED = (state, data) => {
  state.verifyByCallCallingInProgress = false
}

const CANCEL_VERIFY_NUMBER_BY_CALL = (state, data) => {
  state.verifyByCallCallingInProgress = false
}

const START_VERIFY_NUMBER_BY_CALL = (state, data) => {
  state.checkVerifyNumberByCallCounter = -1
  state.verifyByCallCallingInProgress = true
  state.errors.verifyByCallCalling = false
}

export default {
  FETCH_NUMBERS_SUBMIT,
  FETCH_NUMBERS_RESPONSE,
  FETCH_NUMBERS_ERROR_RESPONSE,
  SET_NUMBER_AS_PRIMARY_SUBMIT,
  SET_NUMBER_AS_PRIMARY_RESPONSE,
  SET_NUMBER_AS_PRIMARY_ERROR_RESPONSE,
  DELETE_NUMBER_SUBMIT,
  DELETE_NUMBER_RESPONSE,
  DELETE_NUMBER_ERROR_RESPONSE,
  GET_CALLER_REGIONS_SUBMIT,
  GET_CALLER_REGIONS_RESPONSE,
  GET_CALLER_REGIONS_ERROR_RESPONSE,
  SET_CALLER_REGION_SUBMIT,
  SET_CALLER_REGION_RESPONSE,
  SET_CALLER_REGION_ERROR_RESPONSE,
  ADD_NUMBER_SUBMIT,
  ADD_NUMBER_RESPONSE,
  ADD_NUMBER_ERROR_RESPONSE,
  VERIFY_NUMBER_BY_SMS_SUBMIT,
  VERIFY_NUMBER_BY_SMS_RESPONSE,
  VERIFY_NUMBER_BY_SMS_ERROR_RESPONSE,
  VERIFY_NUMBER_RECIVED_CODE_SUBMIT,
  VERIFY_NUMBER_RECIVED_CODE_RESPONSE,
  VERIFY_NUMBER_RECIVED_CODE_ERROR_RESPONSE,
  VERIFY_NUMBER_BY_CALL_SUBMIT,
  VERIFY_NUMBER_BY_CALL_RESPONSE,
  VERIFY_NUMBER_BY_CALL_ERROR_RESPONSE,
  VERIFY_NUMBER_BY_CALL_VERIFIED_COUNTER,
  VERIFY_NUMBER_BY_CALL_VERIFIED_FAILED,
  VERIFY_NUMBER_BY_CALL_VERIFIED,
  CANCEL_VERIFY_NUMBER_BY_CALL,
  START_VERIFY_NUMBER_BY_CALL
}



// WEBPACK FOOTER //
// ./src/store/modules/user/numbers/mutations.js